import { usePublishDossierUpdate } from "@/entities/utils/publish-dossier-update.ts";
import { Button, ConfirmDialog, Input, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/shared/components";
import { useState } from "react";

const changeFieldOptions = [
    "Handmatig",
    "Prognose",
    "Vestigingen",
    "Opstartplan",
    "Vsm",
    "Tvv",
    "BetrokkenTreinen",
    "BetrokkenStations",
    "Vrijwilligers",
    "Berichten",
];
export function PublishDossierUpdate() {
    const [selectedDossier, setSelectedDossier] = useState("");
    const [selectedChangeField, setSelectedChangeField] = useState("");
    const [confirmOpen, setConfirmOpen] = useState(false);
    const publishDossierUpdate = usePublishDossierUpdate();

    function handlePublishUpdate() {
        if (selectedDossier && selectedChangeField) {
            publishDossierUpdate.mutate(
                { dossierId: selectedDossier, laatstGewijzigdVeld: selectedChangeField },
                {
                    onSuccess: () => setConfirmOpen(false),
                }
            );
        }
    }

    return (
        <div className="grid gap-2">
            <h3 className="text-l text-content-emphasis">Publiceer update voor dossier</h3>
            <div className="flex flex-row justify-between">
                <div className="grid max-w-100 grid-cols-2 gap-2">
                    <Input placeholder="ID van het dossier" value={selectedDossier} onChange={(e) => setSelectedDossier(e.target.value)} />
                    <Select value={selectedChangeField} onValueChange={setSelectedChangeField}>
                        <SelectTrigger>
                            <SelectValue placeholder="Selecteer het laatst gewijzigde veld" />
                        </SelectTrigger>
                        <SelectContent>
                            {changeFieldOptions.map((option) => (
                                <SelectItem key={option} value={option}>
                                    {option}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </div>
                <Button disabled={!selectedDossier || !selectedChangeField} onClick={() => setConfirmOpen(true)}>
                    Publiceer update voor dossier #{selectedDossier}
                </Button>
            </div>
            <ConfirmDialog
                isOpen={confirmOpen}
                onCancel={() => setConfirmOpen(false)}
                onConfirm={handlePublishUpdate}
                isPending={publishDossierUpdate.isPending}
                error={publishDossierUpdate.error}
                title="Publiceer dossier update"
            >
                Hiermee publiceer je een dossier update voor onze generieke berichtenstroom. Weet je zeker dat je dit wil doen?
            </ConfirmDialog>
        </div>
    );
}
